import Task from "../task";
import {MAX_DURATION_DAYS} from "./set-calendar-duration";


export default function taskSetWorkdayDuration(task:Task, value:number | null) {

    if (_.isNaN(value) || !String(value).trim() || value === null) value = 0;

    if (value === 0) {
        task.updateStartDate(null)
        return;
    }

    if (value > MAX_DURATION_DAYS) value = MAX_DURATION_DAYS

    const startDate     = task.startDate ? task.startDate : momentDate()
    const endDate       = task.workSchedule.calculateEndDate(startDate, value);

    task.updateStartEnd(startDate, endDate)
}
